import Slide from './Slide'

export const FullSlide = props => {
  return (
    <Slide
      {...props}
      name='full-slide'
      leftColSize={12}
      leftColSizeLg={1}
      leftContent={
        <div className='mb-4 d-none d-lg-flex'>
          <a
            href='https://www.catapultlabs.xyz/?utm_source=onboarding&utm_medium=logo&utm_campaign=Index&utm_id=Indexcoop'
            target='_blank'
            rel='noreferrer'
            className='d-flex justify-content-center'
          >
            <img
              className='w-50'
              alt='nonsense'
              src='/imgs/our-logo-vertical.png'
            />
          </a>
        </div>
      }
      rightColSizeLg={12}
      rightColSizeLg={11}
    />
  )
}
export default FullSlide
